<template>
  <block
    component-name="block-form-password"
    body-class="grid grid-cols-12 gap-x-ui gap-y-2xl"
  >
    <section
      class="flex flex-col items-stretch w-full col-span-full laptop:col-start-1 laptop:col-end-6 gap-3xl"
    >
      <txt-heading size="regular" :title="texts.title" class="w-full" />
    </section>
    <section
      class="flex flex-col items-stretch w-full col-span-full laptop:col-start-7 laptop:col-end-13 gap-2xl"
    >
      <wrapper-reveal reveal="fade-from-right" class="w-full">
        <div class="text-heading-6" v-html="texts.cta"></div>
      </wrapper-reveal>

      <wrapper-reveal reveal="fade-from-bottom" class="w-full">
        <form-password-recovery
          v-if="
            $attrs.config.variant === 'recovery' ||
            $attrs.config.variant === 'change-request'
          "
          :variant="attrs.config.variant"
          :success-callback="successCallback"
          class="w-full"
        />

        <form-password
          v-else-if="
            $attrs.config.variant === 'reset' ||
            $attrs.config.variant === 'change'
          "
          :variant="attrs.config.variant"
          class="w-full"
        />
      </wrapper-reveal>
    </section>
  </block>
</template>

<script setup>
const nuxtApp = useNuxtApp();
const attrs = useAttrs();

const texts = computed(() => {
  let s = {};
  switch (attrs.config.variant) {
    case "recovery":
      s.title = nuxtApp.$t.labels.password_recovery;
      s.cta = nuxtApp.$t.labels.password_recovery_cta;
      break;

    case "reset":
      s.title = nuxtApp.$t.labels.password_recovery;
      s.cta = nuxtApp.$t.labels.password_recovery_cta;
      break;

    case "change-request":
      s.title = nuxtApp.$t.labels.password_recovery;
      s.cta = nuxtApp.$t.labels.password_change_cta;
      break;

    case "change":
      s.title = nuxtApp.$t.labels.change_password;
      s.cta = nuxtApp.$t.labels.password_change_cta;
      break;
  }

  return s;
});
</script>
